var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-btn',{attrs:{"text":"","title":_vm.$t('whatsapp'),"to":{ name: 'whatsapp' }}},[_c('v-badge',{attrs:{"content":String(_vm.unread),"value":_vm.unread > 0,"color":"green","overlap":""}},[_c('v-img',{attrs:{"src":require('@/assets/new-icons/whatsapp.svg'),"height":"30","width":"30"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }